var map = {
	"./icon-map.png": "1984",
	"./icon-star.png": "77b2",
	"./pic-NARISAWA.png": "bbfe",
	"./pic-TAKIYA.png": "4820",
	"./pic-tz.png": "bf1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3afc";